import { GeogroupService, Partner } from '@geovelo-frontends/commons';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router';

import { queryKeys } from './query-keys';

async function fetchPartnerInvitationCode(partner: Partner): Promise<string | null> {
  if (!partner.geoGroupId) return null;

  const { code } = await GeogroupService.getInvitationLink(partner.geoGroupId);

  return code;
}

/** Never fetched in a webview — computed from the route rather than threaded in as a prop, same
 * pattern as use-stripe-products-query.ts. */
function usePartnerInvitationCodeQuery(
  partner: Partner | undefined | null,
  { enabled = true }: { enabled?: boolean } = {},
) {
  const { pathname } = useLocation();
  const isWebview = pathname.indexOf('/webviews') === 0;

  return useQuery({
    queryKey: queryKeys.partnerInvitationCode.all(partner?.id),
    queryFn: () => fetchPartnerInvitationCode(partner as Partner),
    enabled: !!partner && !isWebview && enabled,
    staleTime: Infinity,
  });
}

export default usePartnerInvitationCodeQuery;
